module.exports = __webpack_public_path__ + "img/thurgood-marshall.064ce0f5.png";